import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class CatalogService {
  private baseApi = environment.baseApi + '/catalog';

  constructor(private http: HttpClient, private loginService: LoginService) { }

  async obtenerEstadisticasGenerales(): Promise<any>{
    const id = this.loginService.chatCrmUser.id;
    const idRol = this.loginService.chatCrmUser.idRol;
    return await this.http.get<any>(`${this.baseApi}/general-statistics/${id}/${idRol}`).toPromise()
    .then(response => response.data);
  }

  get esOperador(){
    return this.loginService.chatCrmUser.idRol == 3;
  }
}
